'use strict';

require('./shim')();



//////////////////
// WEBPACK FOOTER
// ./node_modules/object.fromentries/auto.js
// module id = 1163
// module chunks = 29